import { createFontSizeCSS } from '@hellodarwin/core/lib/theme/global-style';
import TextArea from 'antd/es/input/TextArea';
import styled, { css } from 'styled-components';
const QUEUE_CONTAINER_MAX_HEIGHT = '320px';
const QUEUE_MESSAGE_CONTENT_MAX_HEIGHT = '150px';
const scrollableOverflow = (maxHeight) => css `
  max-height: ${maxHeight};
  overflow-y: auto;
  overscroll-behavior: contain;
`;
export const ChatBackground = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: ${({ $visible }) => ($visible ? 'opacity 0.8s ease' : 'none')};
`;
export const ChatInputWrapper = styled.div `
  width: 100%;
  padding-block-end: ${({ theme }) => theme.spacing.md}px;
  position: relative;
  padding-inline: ${({ theme }) => theme.spacing.xl}px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
export const QueueContainer = styled.div `
  background: ${({ theme }) => theme.colors.white_1};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  border-radius: ${({ theme }) => theme.border_radius.lg};
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  max-width: ${({ theme }) => theme.caps.normal}px;
  margin: 0 auto;
  padding: ${({ theme }) => `${theme.spacing.sm}px ${theme.spacing.md}px`};
  position: relative;
  width: 100%;
  ${scrollableOverflow(QUEUE_CONTAINER_MAX_HEIGHT)}
`;
export const QueueMessageCard = styled.div `
  align-items: flex-start;
  background: ${({ theme }) => theme.colors.beige_3};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  border-radius: ${({ theme }) => theme.border_radius.md};
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm}px;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;
`;
export const QueueMessageContent = styled.div `
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
  min-width: 0;
  min-height: 0;
  padding-right: ${({ theme }) => theme.spacing.xs}px;
  ${scrollableOverflow(QUEUE_MESSAGE_CONTENT_MAX_HEIGHT)}
`;
export const ChatInputContainer = styled.div `
  background: ${({ theme }) => theme.colors.white_1};
  border: 1px solid ${({ theme }) => theme.colors.grey_4};
  width: 100%;
  padding: ${({ theme }) => `${theme.spacing.sm}px ${theme.spacing.md}px`};
  border-radius: ${({ theme }) => theme.border_radius.lg};
  max-width: ${({ theme }) => theme.caps.normal}px;
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  width: 100%;
  margin: 0 auto;
  position: relative;
  &:has(.ant-input:focus) {
    box-shadow: ${({ theme }) => theme.appearance.box_shadow_hover};
  }
  &:has(.ant-input:disabled) {
    background: ${({ theme }) => theme.colors.beige_3};
  }
`;
export const InputWrapper = styled.div `
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
  align-items: flex-end;
`;
export const StyledTextArea = styled(TextArea) `
  &.ant-input {
    ${createFontSizeCSS('body2')}
    padding: 0;
    padding-block: ${({ theme }) => theme.spacing.xs}px;
    border: none;
    line-height: ${({ theme }) => theme.fontsLineHeights.body2};
    transition: all 0.3s;

    &::placeholder {
      line-height: inherit;
    }

    &:focus {
      border-color: none;
      box-shadow: none;
    }
  }
  &:disabled {
    background: transparent;
  }
`;
export const AssistantChatInputQueue = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ $gap }) => (typeof $gap === 'number' ? `${$gap}px` : $gap)};
`;
export const AssistantChatInputQueueHeader = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: ${({ $gap }) => (typeof $gap === 'number' ? `${$gap}px` : $gap)};
`;
export const AssistantChatInputQueueMessageActions = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  width: fit-content;
  height: fit-content;
  line-height: 1;
`;
export const AssistantChatInputComposerControls = styled.div `
  width: 100%;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.md}px;
  align-items: flex-end;
  width: fit-content;
  height: fit-content;
  line-height: 1;
`;
